import ContractsCargoTaxiUpdateParams from "../../../../../common/services/contracts/cargo-taxi/update/contracts-cargo-taxi-update-params";
import TaxiCargoContractEditFormData from "./types/taxi-cargo-contract-edit-form-data";

const create = (
  formData: TaxiCargoContractEditFormData,
  contractUuid: string,
): ContractsCargoTaxiUpdateParams => {
  return {
    contractUuid: contractUuid,
    cancelOrderByTaxiAllowed: formData.cancelOrderByTaxiAllowed,
    contactPassengerAfterMinutes: formData.contactPassengerAfterMinutes,
    editOrderByTaxiAllowed: formData.editOrderByTaxiAllowed,
    isActive: formData.isActive!,
    autoApprovalSwitch: formData.autoApprovalSwitch,
    autoApprovalMinDistance: formData.autoApprovalSwitch
      ? formData.autoApprovalMinDistance
      : 0,
    autoApprovalMinTime: formData.autoApprovalSwitch
      ? formData.autoApprovalMinTime
      : 0,
    approvalDeadlineSwitch: formData.approvalDeadlineSwitch,
    approvalDeadlineTime: formData.approvalDeadlineSwitch
      ? formData.approvalDeadlineTime
      : 0,
  };
};

const taxiCargoContractEditFormRequestFactory = {
  create,
};

export default taxiCargoContractEditFormRequestFactory;
